var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("rb-modal", {
    attrs: {
      show: _vm.visible,
      "handle-close": _vm.closeModal,
      "modal-class-container": "rb-modal-container--fit-to-window",
      "modal-wrapper-class": _vm.modalWrapperClass,
      "modal-class": "rb-modal-pay-over-time",
      "focus-enabled": true,
    },
    scopedSlots: _vm._u([
      {
        key: "modal-content",
        fn: function () {
          return [
            _c("rb-pay-over-time-content", {
              attrs: { "is-modal": true, prices: _vm.prices },
              on: { close: _vm.closeModal },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }